var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("h3", [_vm._v(_vm._s(_vm.$t("MAIN_CONTENT.Devices.manageDevices")))]),
      _vm._v(" "),
      _c("div", [
        _c("p", [
          _vm._v(
            _vm._s(_vm.$t("MAIN_CONTENT.Devices.devicesDescription1Part1")) +
              " "
          ),
          _c("b", [_vm._v(_vm._s(_vm.$t("MAIN_CONTENT.Devices.rememberMe")))]),
          _vm._v(
            " " +
              _vm._s(_vm.$t("MAIN_CONTENT.Devices.devicesDescription1Part2"))
          )
        ]),
        _vm._v(" "),
        _c("p", [
          _vm._v(_vm._s(_vm.$t("MAIN_CONTENT.Devices.devicesDescription2")))
        ])
      ]),
      _vm._v(" "),
      _vm.devices.length === 0
        ? _c("div", { staticClass: "alert alert-info" }, [
            _c("p", [
              _vm._v(_vm._s(_vm.$t("MAIN_CONTENT.Devices.noDevicesMessage")))
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.devices.length > 0
        ? _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-md-3 hidden-sm hidden-xs" }, [
              _c("h4", [_vm._v(_vm._s(_vm.$t("MAIN_CONTENT.Devices.device")))])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-md-3 hidden-sm hidden-xs" }, [
              _c("h4", [
                _vm._v(_vm._s(_vm.$t("MAIN_CONTENT.Devices.activeSince")))
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-md-3 hidden-sm hidden-xs" }, [
              _c("h4", [
                _vm._v(_vm._s(_vm.$t("MAIN_CONTENT.Devices.lastUsed")))
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-md-3 hidden-sm hidden-xs" }, [
              _vm._v("\n\t\t\t \n\t\t")
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm._l(_vm.devices, function(device) {
        return _c("div", { staticClass: "panel panel-default" }, [
          _c("div", { staticClass: "panel-body" }, [
            _c("div", { staticClass: "col-md-3" }, [
              _c("h5", [_vm._v(_vm._s(device.DEVICE_NAME))])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-md-3" }, [
              _c("h5", [
                _vm._v(
                  _vm._s(_vm.$t("MAIN_CONTENT.Devices.activeSince")) +
                    " " +
                    _vm._s(_vm._f("datetime")(device.ISSUED_AT))
                )
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-md-3" }, [
              _c("h5", [
                _vm._v(
                  _vm._s(_vm.$t("MAIN_CONTENT.Devices.lastUsedAt")) +
                    " " +
                    _vm._s(_vm._f("datetime")(device.LAST_USED_AT))
                )
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-md-3 text-right" }, [
              _c(
                "a",
                {
                  staticClass: "btn btn-sm btn-danger",
                  attrs: { href: "javascript: void(0);" },
                  on: {
                    click: function($event) {
                      return _vm.logoutDevice(device.PERSISTENT_LOGIN_GUID)
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("MAIN_CONTENT.Devices.logOutDevice")))]
              )
            ])
          ])
        ])
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }